import api from '@/services/api'

/**
 * 搜索商品名称（自动提示）
 */
export function searchProductNames(query) {
  return api.get('/product/search-names', {
    params: { query, limit: 10 }
  })
}

/**
 * 获取商品列表
 */
export function getProductList(params) {
  return api.get('/product/wholesaler/list', params)
}

/**
 * 推荐商品分类
 */
export function recommendCategory(productName) {
  return api.post('/product/category/recommend', { productName })
}

/**
 * 获取分类列表
 */
export function getCategoryList() {
  return api.get('/product/category/list')
}

/**
 * 获取商品详情
 */
export function getProductDetail(id) {
  return api.get(`/product/${id}`)
}

/**
 * 创建商品
 */
export function createProduct(data) {
  return api.post('/product', data)
}

/**
 * 更新商品
 */
export function updateProduct(id, data) {
  return api.put(`/product/${id}`, data)
}

/**
 * 删除商品
 */
export function deleteProduct(id) {
  return api.delete(`/product/${id}`)
}
